<template>
    <fieldset :disabled="loading">
        <div class="modal fade show" style="display: block" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{finalizer.TargetSystem.Name}}</h5>
                    <button type="button" class="close" data-dismiss="modal"  :aria-label="translate('close')" @click="$emit('onclose')">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-7">
                            <table class="table table-borderless table-sm ozet">
                                <tbody>
                                    <tr>
                                        <td>{{translate('draftEyp.kind')}}</td>
                                        <td>:</td>
                                        <td>{{finalizer.TargetSystem.Kind | targetSystemKind }}</td>
                                    </tr>
                                    <tr v-for="e in finalizer.TargetSystem.ExtraFields" :key="e.Key">
                                        <td>{{e.Key}}</td>
                                        <td>:</td>
                                        <td>{{e.Value}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="col-5">
                            <table class="table table-borderless table-sm ozet">
                                <tbody>
                                    <tr>
                                        <td>{{translate('jobFinalizer.state')}}</td>
                                        <td>:</td>
                                        <td>
                                            <finalizer-state-icon :state="finalizer.State" :show-label="true" />
                                        </td>
                                    </tr>
                                    <tr v-if="canReSend && finalizer.State == 'Success'">
                                        <td></td>
                                        <td></td>
                                        <td>
                                            <input type="button" class="btn btn-outline-success" :value="translate('jobFinalizer.sendAgain')" @click="reSend()"/>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>
                    </div>
                    <div class="row" v-show="finalizer.Results && finalizer.Results.length > 0">
                        <div class="col">
                            <h5>{{translate('jobFinalizer.processHistory')}}</h5>
                            <div class="form-control" style="height:250px; overflow-y:scroll; padding:0">
                                <table class="table table-striped table-condensed table-sm" style="margin-top:-1px">
                                    <tbody>
                                        <tr v-for="r in finalizerResults" :key="r.Date">
                                            <td style="width:1px;" class="text-center">
                                                <finalizer-state-icon :state="r.State" :show-label="false" />
                                                <div v-show="r.Count > 1" title="Tekrar sayısı" class="text-danger" style="font-size:12px;">x{{r.Count}}</div>
                                            </td>
                                            <td>
                                                <div>{{r.Description}}</div>
                                                <small v-if="r.ExceptionData" class="text-muted">{{r.ExceptionData.Message}}</small>
                                                <div v-if="r.User">{{r.User.FullName}}</div>
                                            </td>
                                            <td class="text-right">{{r.Date | datetime}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer footer-button-container">
                    <button type="button" class="btn btn-outline-secondary" @click="$emit('onclose')">{{translate('close')}}</button>
                    <!-- <button type="submit" class="btn btn-success" style="width:100px;" @click="$refs.imzalayici.sign()">İmzala</button> -->
                </div>
                </div>
            </div>
        </div>
    </fieldset>
</template>
<script>
import axios from 'axios';
import finalizerStateIcon from '../components/FinalizerStateIcon.vue';

export default {
    data(){
        return {
            loading : false,
            hasDetsisNo: false,
            detsisNo: null,
            listHasKurumName: false,
        };
    },
    props: {
        finalizer: Object,
        canReSend: Boolean
    },
    created() {
        this.checkDetsis()
    },
    components: {
        finalizerStateIcon
    },
    methods: {
        checkDetsis(){
            let fieldArray = this.finalizer.TargetSystem.ExtraFields
            for (var i in fieldArray) {
                if (fieldArray[i].Key == "Detsis No") {
                    this.detsisNo = fieldArray[i].Value;
                    this.hasDetsisNo = true;
                }
            }
            if(this.hasDetsisNo){
                this.getKurumName()
            }
        },
        async getKurumName(){
            await axios.get(window.settings.detsisApiUrl+ "Detsis/getByNumber?detsisNo=" + this.detsisNo).then(x => {
                var kurumData = {
                    Key: "Kurum Adı",
                    Value: x.data.Data.Ad
                }
                let fieldArray = this.finalizer.TargetSystem.ExtraFields
                for (var i in fieldArray) {
                    if (fieldArray[i].Key == "Kurum Adı") {
                        this.listHasKurumName = true;
                    }
                }
                if(!this.listHasKurumName){
                    this.finalizer.TargetSystem.ExtraFields.push(kurumData)
                }
            }).catch(() => {
                var kurumData = {
                    Key: "Kurum Adı",
                    Value: this.translate('errors.cantAccessOrganisationName')
                }
                let fieldArray = this.finalizer.TargetSystem.ExtraFields
                for (var i in fieldArray) {
                    if (fieldArray[i].Key == "Kurum Adı") {
                        this.listHasKurumName = true;
                    }
                }
                if(!this.listHasKurumName){
                    this.finalizer.TargetSystem.ExtraFields.push(kurumData)
                }
            })
        },
        reSend(){
            if(confirm(this.translate('warnings.willResend')))
                this.$emit('resend', this.finalizer);
        }
    },
    computed:{
        finalizerResults(){
            return [...this.finalizer.Results].reverse(); //.reverse();
        }
    }
}
</script>